const emailData = [
    {
      id: 1,
      from: "Maggy Rime",
      thumbnail: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
      subject: "Morbi ut odio.",
      time: "4:25 PM",
      emailExcerpt:"Nam ultrices, libero non mattis pulvinar, nulla pede ullamcorper augue",
      emailContent:
        "<p>Nam ultrices, libero non mattis pulvinar, nulla pede ullamcorper augue, a suscipit nulla elit ac nulla. Sed vel enim sit amet nunc viverra dapibus. Nulla suscipit ligula in lacus.\n\nCurabitur at ipsum ac tellus semper interdum. Mauris ullamcorper purus sit amet nulla. Quisque arcu libero, rutrum ac, lobortis vel, dapibus at, diam. <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. </p>", 
      unread: true,
      attachment: false,
      starred: true,
      important: false,
      inbox: true,
      sent: false,
      draft: false,
      spam: false,
      trash: false,
      label: "Technology"
    },
    {
      id: 2,
      from: "Nicolas Harget",
      thumbnail: "https://randomuser.me/api/portraits/thumb/men/65.jpg",
      subject: "Maecenas rhoncus aliquam lacus.",
      time: "6:39 AM",
      emailExcerpt:"Libero non mattis pulvinar, nulla pede ullamcorper augue",
      emailContent:
        "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. </p>Quisque id justo sit amet sapien dignissim vestibulum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Nulla dapibus dolor vel est. Donec odio justo, sollicitudin ut, suscipit a, feugiat et, eros.\n\nVestibulum ac est lacinia nisi venenatis tristique. Fusce congue, diam id ornare imperdiet, sapien urna pretium nisl, ut volutpat sapien arcu sed augue. Aliquam erat volutpat.\n\nIn congue. Etiam justo. Etiam pretium iaculis justo.",
      unread: true,
      attachment: false,
      starred: true,
      important: false,
      inbox: false,
      sent: false,
      draft: true,
      spam: false,
      trash: false,
      label: "Finance"
    },
    {
      id: 3,
      from: "Dionysus Samworth",
      thumbnail: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
      subject: "Mauris viverra diam vitae quam",
      time: "7:01 PM",
      emailExcerpt:"Consectetur adipiscing elit, sed do eiusmod tempor incididunt",
      emailContent:
        "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.</p> <p>Quisque id justo sit amet sapien dignissim vestibulum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Nulla dapibus dolor vel est. Donec odio justo, sollicitudin ut, suscipit a, feugiat et, eros.",
      unread: false,
      attachment: false,
      starred: false,
      important: true,
      inbox: false,
      sent: true,
      draft: false,
      spam: false,
      trash: false,
      label: "Technology"
    },
    {
      id: 4,
      from: "Nathalie Harland",
      thumbnail: "http://dummyimage.com/100x100.png/ff4444/ffffff",
      subject: "Nam tristique tortor eu pede.",
      time: "8:43 PM",
      emailExcerpt:"Laboris nisi ut aliquip ex ea commodo consequat",
      emailContent:
        "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. </p><p>Morbi porttitor lorem id ligula. Suspendisse ornare consequat lectus. In est risus, auctor sed, tristique in, tempus sit amet, sem.\n\nFusce consequat. Nulla nisl. Nunc nisl.\n\nDuis bibendum, felis sed interdum venenatis, turpis enim blandit mi, in porttitor pede justo eu massa. Donec dapibus. Duis at velit eu est congue elementum.</p>",
      unread: false,
      attachment: true,
      starred: true,
      important: false,
      inbox: false,
      sent: false,
      draft: true,
      spam: false,
      trash: false,
      label: "Finance"
    },
    {
      id: 5,
      from: "Chevalier Joron",
      thumbnail: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
      subject: "Vestibulum ante ipsum",
      time: "5:55 AM",
      emailExcerpt:"Maecenas ut massa quis augue luctus tincidunt",
      emailContent:
        "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. </p><p>Maecenas ut massa quis augue luctus tincidunt. Nulla mollis molestie lorem. Quisque ut erat.\n\nCurabitur gravida nisi at nibh. In hac habitasse platea dictumst. Aliquam augue quam, sollicitudin vitae, consectetuer eget, rutrum at, lorem.</p>",
      unread: false,
      attachment: false,
      starred: false,
      important: true,
      inbox: true,
      sent: false,
      draft: false,
      spam: false,
      trash: false,
      label: "Finance"
    },
    {
      id: 6,
      from: "Robyn Twells",
      thumbnail: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
      subject: "Ut tellus.",
      time: "10:26 AM",
      emailExcerpt:"Cum sociis natoque penatibus et magnis dis parturient",
      emailContent:
        "<p>>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
      unread: false,
      attachment: true,
      starred: false,
      important: true,
      inbox: true,
      sent: false,
      draft: false,
      spam: false,
      trash: false,
      label: "Health"
    },
    {
      id: 7,
      from: "Averell Brydell",
      thumbnail: "http://dummyimage.com/100x100.png/ff4444/ffffff",
      subject: "In hac habitasse platea dictumst.",
      time: "12:55 PM",
      emailExcerpt:"Vestibulum rutrum rutrum neque magnis",
      emailContent:
        "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
      unread: true,
      attachment: true,
      starred: false,
      important: false,
      inbox: true,
      sent: false,
      draft: false,
      spam: false,
      trash: false,
      label: ""
    },
    {
      id: 8,
      from: "Nannie Ineson",
      thumbnail: "http://dummyimage.com/100x100.png/cc0000/ffffff",
      subject: "Sed sagittis.",
      time: "1:05 AM",
      emailExcerpt:"Natoque rutrum rutrum neque magnis",
      emailContent:
        "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
      unread: false,
      attachment: true,
      starred: false,
      important: true,
      inbox: false,
      sent: false,
      draft: false,
      spam: true,
      trash: false,
      label: ""
    },
    {
      id: 9,
      from: "Hedvige Keble",
      thumbnail: "http://dummyimage.com/100x100.png/dddddd/000000",
      subject: "Duis bibendum.",
      time: "1:44 PM",
      emailExcerpt:"Praesent id massa id nisl venenatis lacinia",
      emailContent:
        "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
      unread: false,
      attachment: true,
      starred: false,
      important: false,
      inbox: false,
      sent: false,
      draft: false,
      spam: false,
      trash: true,
      label: "Technology"
    },
    {
      id: 10,
      from: "Othilia Briston",
      thumbnail: "http://dummyimage.com/100x100.png/ff4444/ffffff",
      subject: "Proin interdum mauris non ligula pellentesque ultrices.",
      time: "7:37 AM",
      emailExcerpt:"Vestibulum rutrum rutrum neque magnis",
      emailContent:
        "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
      unread: false,
      attachment: true,
      starred: true,
      important: false,
      inbox: false,
      sent: true,
      draft: false,
      spam: false,
      trash: false,
      label: "Health"
    },
    {
      id: 11,
      from: "Michel Foulgham",
      thumbnail: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
      subject: "Nulla mollis molestie lorem.",
      time: "10:44 AM",
      emailExcerpt:"Cras id massa id nisl venenatis lacinia",
      emailContent:
        "<p>Nullam sit amet turpis elementum ligula vehicula consequat. Morbi a ipsum. Integer a nibh.\n\nIn quis justo. Maecenas rhoncus aliquam lacus. Morbi quis tortor id nulla ultrices aliquet.\n\nMaecenas leo odio, condimentum id, luctus nec, molestie sed, justo. Pellentesque viverra pede ac diam. Cras pellentesque volutpat dui.</p>",
      unread: false,
      attachment: false,
      starred: true,
      important: false,
      inbox: true,
      sent: false,
      draft: false,
      spam: false,
      trash: false,
      label: "Technology"
    },
    {
      id: 12,
      from: "Elsie Carlucci",
      thumbnail: "http://dummyimage.com/100x100.png/cc0000/ffffff",
      subject: "Aenean lectus.",
      time: "12:01 PM",
      emailExcerpt:"Suspendisse potenti. In eleifend quam a odio",
      emailContent:
        "<p>Suspendisse potenti. In eleifend quam a odio. In hac habitasse platea dictumst.\n\nMaecenas ut massa quis augue luctus tincidunt. Nulla mollis molestie lorem. Quisque ut erat.\n\nCurabitur gravida nisi at nibh. In hac habitasse platea dictumst. Aliquam augue quam, sollicitudin vitae, consectetuer eget, rutrum at, lorem.</p>",
      unread: false,
      attachment: false,
      starred: false,
      important: false,
      inbox: true,
      sent: false,
      draft: true,
      spam: false,
      trash: true,
      label: "Finance"
    },
    {
      id: 13,
      from: "Forest Hehir",
      thumbnail: "http://dummyimage.com/100x100.png/dddddd/000000",
      subject: "Morbi a ipsum.",
      time: "2:58 PM",
      emailExcerpt:"Morbi vel lectus in quam fringilla rhoncus",
      emailContent:
        "<p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Proin risus. Praesent lectus.\n\nVestibulum quam sapien, varius ut, blandit non, interdum in, ante. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Duis faucibus accumsan odio. Curabitur convallis.\n\nDuis consequat dui nec nisi volutpat eleifend. Donec ut dolor. Morbi vel lectus in quam fringilla rhoncus.</p>",
      unread: false,
      attachment: true,
      starred: true,
      important: true,
      inbox: false,
      sent: true,
      draft: false,
      spam: false,
      trash: false,
      label: "Health"
    },
    {
      id: 14,
      from: "Pauli Boase",
      thumbnail: "http://dummyimage.com/100x100.png/cc0000/ffffff",
      subject: "Aliquam erat volutpat.",
      time: "7:47 AM",
      emailExcerpt:"Lorem vel lectus in quam fringilla rhoncus",
      emailContent:
        "<p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Proin risus. Praesent lectus.\n\nVestibulum quam sapien, varius ut, blandit non, interdum in, ante. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Duis faucibus accumsan odio. Curabitur convallis.\n\nDuis consequat dui nec nisi volutpat eleifend. Donec ut dolor. Morbi vel lectus in quam fringilla rhoncus.</p>",
      unread: false,
      attachment: false,
      starred: true,
      important: false,
      inbox: false,
      sent: false,
      draft: false,
      spam: false,
      trash: true,
      label: "Finance"
    },
    {
      id: 15,
      from: "Francene Shermore",
      thumbnail: "http://dummyimage.com/100x100.png/5fa2dd/ffffff",
      subject: "Nunc rhoncus dui vel sem.",
      time: "4:42 PM",
      emailExcerpt:"Suspendisse potenti. In eleifend quam a odio",
      emailContent:
        "<p>Suspendisse potenti. In eleifend quam a odio. In hac habitasse platea dictumst.\n\nMaecenas ut massa quis augue luctus tincidunt. Nulla mollis molestie lorem. Quisque ut erat.\n\nCurabitur gravida nisi at nibh. In hac habitasse platea dictumst. Aliquam augue quam, sollicitudin vitae, consectetuer eget, rutrum at, lorem.</p>",
      unread: false,
      attachment: true,
      starred: false,
      important: false,
      inbox: false,
      sent: false,
      draft: false,
      spam: false,
      trash: true,
      label: "Technology"
    },
    {
      id: 16,
      from: "Elbert Krauss",
      thumbnail: "http://dummyimage.com/100x100.png/ff4444/ffffff",
      subject: "Nulla tempus.",
      time: "11:54 PM",
      emailExcerpt:"Vestibulum rutrum rutrum neque magnis",
      emailContent:
        "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
      unread: true,
      attachment: false,
      starred: false,
      important: true,
      inbox: true,
      sent: false,
      draft: false,
      spam: false,
      trash: true,
      label: "Finance"
    },
    {
      id: 17,
      from: "Bale Hickisson",
      thumbnail: "http://dummyimage.com/100x100.png/cc0000/ffffff",
      subject: "Quisque id justo sit amet sapien dignissim vestibulum.",
      time: "12:25 PM",
      emailExcerpt:"Natoque rutrum rutrum neque magnis",
      emailContent:
        "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
      unread: true,
      attachment: false,
      starred: false,
      important: false,
      inbox: false,
      sent: false,
      draft: false,
      spam: true,
      trash: false,
      label: "Health"
    },
    {
      id: 18,
      from: "Diandra Leppo",
      thumbnail: "http://dummyimage.com/100x100.png/dddddd/000000",
      subject: "Curabitur at ipsum ac tellus semper interdum.",
      time: "7:02 AM",
      emailExcerpt:"Natoque rutrum rutrum neque magnis",
      emailContent:
        "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
      unread: false,
      attachment: false,
      starred: false,
      important: true,
      inbox: false,
      sent: true,
      draft: false,
      spam: false,
      trash: false,
      label: "Technology"
    },
    {
      id: 19,
      from: "Wynn Beden",
      thumbnail: "http://dummyimage.com/100x100.png/cc0000/ffffff",
      subject: "Morbi porttitor lorem id ligula.",
      time: "8:38 PM",
      emailExcerpt:"Cum rutrum rutrum neque magnis",
      emailContent:
        "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
      unread: true,
      attachment: false,
      starred: false,
      important: false,
      inbox: false,
      sent: false,
      draft: true,
      spam: false,
      trash: false,
      label: "Health"
    },
    {
      id: 20,
      from: "Jean Abbitt",
      thumbnail: "http://dummyimage.com/100x100.png/ff4444/ffffff",
      subject: "Donec posuere metus vitae ipsum.",
      time: "7:10 PM",
      emailExcerpt:"Aenean rutrum rutrum neque magnis",
      emailContent:
        "<p>Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Vivamus vestibulum sagittis sapien. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.\n\nEtiam vel augue. Vestibulum rutrum rutrum neque. Aenean auctor gravida sem.\n\nPraesent id massa id nisl venenatis lacinia. Aenean sit amet justo. Morbi ut odio.</p>",
      unread: false,
      attachment: true,
      starred: true,
      important: true,
      inbox: true,
      sent: false,
      draft: false,
      spam: false,
      trash: false,
      label: "Finance"
    }
  ]

export default emailData;
